import React, { useState, useEffect } from "react";
import ct from "class-types.macro";
import { ImageLeftCarouselModel } from "../Models/PageCreatorPage";
import ProductCarouselContainer from "./ProductCarouselContainer";

interface ImageLeftCarouselProps extends ImageLeftCarouselModel {
  couponCode: string;
}

const ImageLeftCarousel = ({
  backgroundColor,
  imageUrl,
  imageAltText,
  tabletImageUrl,
  tabletImageAltText,
  couponCode,
  products,
  productListingUrl,
}: ImageLeftCarouselProps) => {
  const [isTabletView, setIsTabletView] = useState(
    window.innerWidth >= 431 && window.innerWidth <= 945,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsTabletView(window.innerWidth >= 431 && window.innerWidth <= 945);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{ backgroundColor }}
      className={`carousel-wrap ${ct("rounded", "p-4", "m-0")}`}
    >
      <div className={ct("relative")}>
        <div
          className={ct(
            "lt:absolute",
            "lt:top-1/2",
            "lt:transform",
            "lt:-translate-y-1/2",
            "mb-4",
            "lt:mb-0",
          )}
        >
          <a className={ct("mb-4", "mr-auto", "pr-4")} href={productListingUrl}>
            <img
              src={isTabletView && tabletImageUrl ? tabletImageUrl : imageUrl}
              alt={
                isTabletView && tabletImageUrl
                  ? tabletImageAltText
                  : imageAltText
              }
              style={{
                width: isTabletView && tabletImageUrl ? "100%" : "320px",
                height: isTabletView && tabletImageUrl ? "auto" : "320px",
              }}
              className={ct("lt:float-left")}
            />
          </a>
        </div>
        <ProductCarouselContainer
          items={products}
          discountCode={couponCode}
          containerClassNames={ct("ml-0", "lt:ml-110")}
        />
      </div>
    </div>
  );
};

export default ImageLeftCarousel;
